import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCalendarAlt, FaArrowRight } from 'react-icons/fa';
import { Info } from 'lucide-react';
import './News.css';
import API_BASE_URL from '../../../config/api';

const News = () => {
  const [noticias, setNoticias] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNews();
  }, []);

  const fetchNews = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/news`);
      if (response.ok) {
        const data = await response.json();
        // Pega apenas as 3 primeiras notícias
        setNoticias(data.slice(0, 3));
      }
    } catch (error) {
      console.error('Error fetching news:', error);
    } finally {
      setLoading(false);
    }
  };

  const getImageUrl = (imageUrl) => {
    if (!imageUrl) return '/CDP_logo.png';
    if (imageUrl.startsWith('http')) return imageUrl;
    return `${API_BASE_URL}${imageUrl.startsWith('/') ? imageUrl : '/' + imageUrl}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-PT', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  if (loading) {
    return (
      <section id="noticias" className="news section-padding bg-light">
        <div className="container">
          <div className="news-header">
            <h2>Últimas Notícias</h2>
            <p>A carregar notícias...</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="noticias" className="news section-padding bg-light">
      <div className="container">
        <div className="news-header animate-in">
          <span className="news-subtitle">Fique por dentro</span>
          <h2 className="news-title">Últimas Notícias</h2>
          <div className="news-header-line"></div>
          <p className="news-description">
            Acompanhe as últimas novidades, eventos e resultados de topo das nossas equipas.
          </p>
        </div>

        {noticias.length > 0 ? (
          <>
            <div className="news-grid">
              {noticias.map((noticia, index) => (
                <Link
                  key={noticia.id}
                  to={`/noticias/${noticia.slug}`}
                  className="destaque-card animate-in"
                  style={{ '--delay': `${0.1 * (index + 1)}s` }}
                >
                  <div style={{ position: 'relative', overflow: 'hidden' }}>
                    <img
                      src={getImageUrl(noticia.imageUrl)}
                      alt={noticia.title}
                      className="destaque-image"
                    />
                    <span className="destaque-badge">{noticia.category || 'Clube'}</span>
                  </div>
                  <div className="destaque-content">
                    <div className="destaque-date">
                      <FaCalendarAlt />
                      {formatDate(noticia.publishedAt)}
                    </div>
                    <h3>{noticia.title}</h3>
                    <p>{noticia.excerpt}</p>
                    <span className="destaque-link">
                      Ler mais <FaArrowRight />
                    </span>
                  </div>
                </Link>
              ))}
            </div>

            <div className="text-center animate-in" style={{ marginTop: '50px', '--delay': '0.4s' }}>
              <Link to="/noticias" className="btn-premium-outline">
                Ver Todas as Notícias <FaArrowRight />
              </Link>
            </div>
          </>
        ) : (
          <div className="news-empty-state glass-card animate-in">
            <Info size={32} />
            <p>Nenhuma notícia publicada ainda.</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default News;